/** Domains Types */
export const GET_DOMAINS = 'GET_DOMAINS';
export const GET_DOMAINS_SUCCESS = 'GET_DOMAINS_SUCCESS';

export const CREATE_DOMAIN = 'CREATE_DOMAIN';
export const EDIT_DOMAIN = 'EDIT_DOMAIN';
export const DELETE_DOMAIN = 'DELETE_DOMAIN';

/** End */
